import { Injectable } from '@angular/core';
import { SharedService } from "./shared.service";
import { ContactConsigneeParams, StoreParams } from '../Models/master';
import { GetSpraPriceParam, ProductSearchParam } from '../Models/product';
import { DealerParam } from '../Models/ops';

@Injectable()
export class MasterService {

  constructor( private _sharedService: SharedService) { }

  public GetAllOffices(OfficeId?: number) {
    let Data = {
      OfficeId: OfficeId
    }
    return this._sharedService.Get("Master/GetAllOffices", Data);

  }


  public GetContactDetailByRefId(refId: number) {
    let Data = { refId: refId }
    return this._sharedService.Get("Master/GetContactDetailByRefId", Data);

  }
//Added By Rahul Yadav on 15/12/2020 for
  public GetAllProductCategory(IsForRental:boolean=false) {
    let Data = {IsForRental:IsForRental};
    return this._sharedService.Get("Product/GetAllProductCategory",Data);

  }

  //Added By Rahul Yadav on 12/7/2020 
  public GetQAStatus() {
    return this._sharedService.Get("Master/GetQAStatus");
  }
  //Added By Rahul Yadav on 15/12/2020 for
  public GetAllProductGroup() {
    return this._sharedService.Get("Product/GetAllProductGroup");

  }
   //Added By Rahul Yadav on 15/12/2020 for
   public GetAllProductCode(productSearchParam:ProductSearchParam) {
    return this._sharedService.Post("Product/GetAllProductCode",productSearchParam,true);

  }


  public GetContactConsignee(contactConsigneeParams:ContactConsigneeParams){
    return this._sharedService.Post("Master/GetContactConsignee", contactConsigneeParams);
  }
  

  public GetStateList(stateId?:number){
    let Data = { stateId : stateId }
    return this._sharedService.Get("Master/GetStateList", Data);
  }

  public GetEmployeeHierarchyList(employeeId:number){
    let Data = { employeeId : employeeId }
    return this._sharedService.Get("Master/GetEmployeeHierarchyList", Data);
  }

  public GetStoreList(storeParams:StoreParams){
    return this._sharedService.Post("Master/GetStoreList", storeParams);
  }

  public GetProductNationalStock(productid:number,gradeId:number=1){
    let Data = {"productId":productid,"gradeId":gradeId}
    return this._sharedService.Get("Product/GetProductNationalStock", Data,true);
  }
  


  public GetProductSegmentWarranty(ProdsegmentId:number, SaleTypeCode:string){
    let Data = {"ProdsegmentId":ProdsegmentId, "SaleTypeCode":SaleTypeCode}
    return this._sharedService.Get("Product/GetProductSegmentWarranty", Data,true);
  }
  
  

  public GetProductCounter(productcode:string){
    let Data = {"productcode":productcode,"isMultiple":false}
    return this._sharedService.Get("Master/GetProductCounter", Data);
  }


  public GetDistinctProductCounter(productcode:string){
    let Data = {"productcode":productcode}
    return this._sharedService.Get("Master/GetDistinctProductCounter", Data);
  }



  /// ADDED BY RAJAN SINGH ON 04 MARCH 2021 FOR "TO GET TECHNICAL MASTER LIST"
  public GetTechnical(Condition:string){
    let Data = {"Condition":Condition}
    return this._sharedService.Get("Master/GetTechnical", Data);
  }

  //ProductCode added by swati on 14/04/2021
  public GetAllProductByTechnicalId(technicalId?:Number,productId?:Number,productCode?:string){
  if(productId== undefined){
    productId = 0 ;
  }
    let Data = {"technicalId":technicalId,"productId":productId,"productCode":productCode}
    return this._sharedService.Get("Product/GetAllProductByTechnicalId", Data,true);
  }

  
  // ADDED BY RAJAN SINGH ON 17 MARCH 2021 -->> TO GET ALL COUNTER LIST AVAILABLE
  public GetAllCounterList(IsForSpra:boolean = true) {
    let Data = {IsForSpra:IsForSpra};
    return this._sharedService.Get("Product/GetAllCounterList", Data);

  }
  
  
  
  //added by swati on 05/03/2021
  public GetDistance(){  
    return this._sharedService.Get("Master/GetDistanceForSPRA");
  }
  //end of addition by swati
  


  // ADDED BY RAJAN SINGH ON 18 MARCH 2021 -->> TO GET SPRA PRICE FROM SPRAPRICELIST
  public GetSpraPrice(_GetSpraPriceParam:GetSpraPriceParam) {
    return this._sharedService.Post("Product/GetSpraPrice", _GetSpraPriceParam);

  }
  
// ADDED BY RAJAN SINGH ON 18 MARCH 2021 -->> TO GET TONNER YEALD
public  GetProductYield(productId:number) {
  let Data = {"ProductId":productId};
  return this._sharedService.Get("Product/GetProductYield",Data );

}



// ADDED BY RAJAN SINGH ON 23 MARCH 2021 -->> TO GET TONNER YEALD
public  GetCustomerAmcvCounterWise(CompanyId:number) {
  let Data = {"CompanyId":CompanyId};
  return this._sharedService.Get("Transaction/GetCustomerAmcvCounterWise",Data );

}

//ADDED BY RAJAN SINGH ON 24 MARCH 2021 -->> TO GET COLLECTION DAYS AND OVERDUE DAYS BY COMPANYID
public  GetCollectionDaysBycompanyId(CompanyId:number) {
  let Data = {"CompanyId":CompanyId};
  return this._sharedService.Get("Master/GetCollectionDaysBycompanyId",Data );

}

//ADDED BY Rahul yadav ON 11/04/2021 -->> TO GET Spra Enquiry List
public  GetSpraEnquiryList(EmployeeCode:string) {
  let Data = {"EmployeeCode":EmployeeCode};
  return this._sharedService.Get("Master/GetSpraEnquiryDetails",Data );

}

//ADDED BY Rahul yadav ON 12/04/2021 -->> TO GET Encrypted key
public  GetEncrptedValue(EnquiryId:number,CompanyId:number,PrimaryContactId:number) {
  let Data = {"EnquiryId":EnquiryId,"CompanyId":CompanyId,"PrimaryContactId":PrimaryContactId};
  return this._sharedService.Get("Master/GetQueryStringValueForNewContact",Data );
}


public  GetEmployeeCodeForAutocomplete(SearchValue:string) {
  let Data = {"SearchValue":SearchValue};
  return this._sharedService.Get("Master/GetEmployeeCodeForAutocomplete",Data,true);

}

public  GetExistingCsaRate(RefID:number) {
  let Data = {"RefID":RefID};
  return this._sharedService.Get("Master/GetExistingCsaRate",Data );

}

// Added by Swati on 07/04/2021
// public  GetSPRAPriceListData(ProductID:number,CounterID:number,SaleType:string,DistanceID:number) {
//   let Data = {"ProductID":ProductID, "CounterID":CounterID, "SaleType":SaleType,"DistanceID":DistanceID };
//   return this._sharedService.Get("Transaction/GetSPRAPriceListData",Data );

// }
public async GetSPRAPriceListData(ProductID:number,CounterID:number,SaleType:string,DistanceID:number) {
  let Data = {"ProductID":ProductID, "CounterID":CounterID, "SaleType":SaleType,"DistanceID":DistanceID };
  let httpData = await this._sharedService.getDataSynchronous("Transaction/GetSPRAPriceListData",Data );
  return httpData;
}


public GetDealer(_DealerParam:DealerParam) {
  return this._sharedService.Post("Transaction/GetDealer",_DealerParam);
}

public  GetEmployeeListOnBasisOfOffice(strCond:string,employeeId:number) {
  let Data = {"strCond":strCond,"employeeid":employeeId};
  return this._sharedService.Get("Master/GetEmployeeListOnBasisOfOffice",Data );

}

public getASCForOffice(_DealerParam:DealerParam) {
  return this._sharedService.Post("Transaction/getASCForOffice",_DealerParam);
}



}
